module.exports = __webpack_public_path__ + "static/media/South-Africa.d99c3b46.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backs/South-Africa.jpg
// module id = 990
// module chunks = 0